import { render, staticRenderFns } from "./SharedMediaCards.vue?vue&type=template&id=a08b702a&"
import script from "./SharedMediaCards.vue?vue&type=script&lang=js&"
export * from "./SharedMediaCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports